export class ActiveUserSessionInfo {
	UserAgent:string = ""
	IPAddress:string = ""
	SocketID:string = ""
	IsActive:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.UserAgent = data.UserAgent;
		this.IPAddress = data.IPAddress;
		this.SocketID = data.SocketID;
		this.IsActive = data.IsActive || false;
	}
}